/* global globalThis, RequestIdleCallbackHandle, RequestIdleCallbackDeadline */
import raf from 'raf';

// We should probably audit all of the features polyfilled by core-js/stable
// and select only the ones that we actually need, to reduce bundle size.
require('core-js/stable');

// Assign prefixed AudioContext in Safari to the regular name
if (
  typeof globalThis !== 'undefined' &&
  typeof globalThis.AudioContext !== 'function'
) {
  const { webkitAudioContext } = (globalThis as { webkitAudioContext?: AudioContext });
  if (typeof webkitAudioContext === 'function') {
    globalThis.AudioContext = webkitAudioContext;
  }
}

if (
  typeof globalThis !== 'undefined' &&
  (!globalThis.requestAnimationFrame || !globalThis.cancelAnimationFrame)
) {
  raf.polyfill(globalThis);
}

if (
  typeof globalThis !== 'undefined' &&
  (!globalThis.requestIdleCallback || !globalThis.cancelIdleCallback)
) {
  // Shim using setTimeout (based on https://gist.github.com/paullewis/55efe5d6f05434a96c36)
  globalThis.requestIdleCallback = (cb: (deadline?: RequestIdleCallbackDeadline) => void) => setTimeout(() => {
    const start = Date.now();

    cb({
      didTimeout: false,
      timeRemaining: () => Math.max(0, 50 - (Date.now() - start)),
    });
  }, 1);

  globalThis.cancelIdleCallback = (id: RequestIdleCallbackHandle) => clearTimeout(id);
}
